import type { CSSProperties } from 'react';

import dynamic from 'next/dynamic';

import { CampaignPromotionItemViewModel, LinkViewModel } from '@api/index';
import { useDevice } from '@contexts/device';

const CampaignPromotionsDesktop = dynamic(() =>
  import('./CampaignPromotionsDesktop').then(
    ({ CampaignPromotionsDesktop }) => CampaignPromotionsDesktop
  )
);
const CampaignPromotionsMobile = dynamic(() =>
  import('./CampaignPromotionsMobile').then(
    ({ CampaignPromotionsMobile }) => CampaignPromotionsMobile
  )
);

export interface CampaignPromotionsProps {
  data: CampaignPromotionItemViewModel[];
  link?: LinkViewModel;
  title?: string;
  text?: string;
  showHeader?: boolean;
  linkPosition?: CSSProperties['justifyContent'];
  imagesKey?: 'images' | 'homePageImages';
  fontSize?: number;
}

export const CampaignPromotions = (props: CampaignPromotionsProps) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <CampaignPromotionsDesktop {...props} />
  ) : (
    <CampaignPromotionsMobile {...props} />
  );
};
